import React, { Component } from "react";
import ProfileImgSummaryPanelView from "presentational/upload/ProfileImgSummaryPanelView";
import LoadingModalView from "presentational/common/modals/LoadingModalView";
import { withStore } from "store/storeHandler";
import { uploadImage } from "lib/imageUploadHelper";
import { withToken } from "lib/forceTokenRenewComponent";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

class ProfileImgSummaryPanel extends Component {
  static propTypes = {
    imageDataURL: PropTypes.string.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onUploadComplete: PropTypes.func.isRequired
  };

  state = {
    isUploading: false
  };

  handleSubmitClick = async () => {
    const {
      imageDataURL,
      onUploadComplete,
      UserProfileActions,
      forceRenewTokenWT,
      AppErrorActions,
      NoticeModalActions,
      getIdTokenWT
    } = this.props;
    const { isUploading } = this.state;

    if (isUploading) return null;

    await this.setState({ isUploading: true });

    const hasSucceed = await forceRenewTokenWT();
    if (!hasSucceed) {
      this.setState({ isUploading: false });
      return null;
    }

    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) {
      this.setState({ isUploading: false });
      return null;
    }

    let filename;
    try {
      filename = await uploadImage("profile", imageDataURL, idToken);
    } catch (error) {
      this.setState({ isUploading: false });
      AppErrorActions.setSafeAppError(error);
      NoticeModalActions.openModal({
        content: <TXT name="msg_commonNetworkError" />
      });
      return null;
    }

    try {
      await UserProfileActions.uploadProfileImg({ filename, idToken });
    } catch (error) {
      this.setState({ isUploading: false });
      AppErrorActions.setSafeAppError(
        Error(`rollback problem => unlinkedProfileImageFile: "${filename}"`)
      );
      AppErrorActions.setFatalAppError(error);
      return null;
    }
    this.setState({ isUploading: false });
    UserProfileActions.deleteMyProfile();
    onUploadComplete();
  };

  render() {
    const { imageDataURL, onBackClick } = this.props;
    const { isUploading } = this.state;

    return (
      <div>
        <ProfileImgSummaryPanelView
          imageDataURL={imageDataURL}
          onBackClick={onBackClick}
          onSubmit={this.handleSubmitClick}
        />
        <LoadingModalView open={isUploading} />
      </div>
    );
  }
}

export default withStore({
  dispatchMap: ["userProfile", "appError", "noticeModal"]
})(withToken(ProfileImgSummaryPanel));
